import React from 'react';
import { Modal, ModalDialog, Card, CardContent } from '@mui/joy';
import ResultsTable from '../ResultsTable';

/**
 * Modal for displaying test field results
 */
const TestResultModal = ({ 
  open, 
  onClose, 
  result 
}) => {
  if (!open || !result) return null;

  return (
    <Modal
      open
      onClose={onClose}
      style={{ zIndex: "10000" }}
    >
      <ModalDialog>
        <Card
          style={{
            overflowY: "auto",
            height: "fit-content"
          }}
        >
          <CardContent>
            <ResultsTable result={result} />
          </CardContent>
        </Card>
      </ModalDialog>
    </Modal>
  );
};

export default TestResultModal;
